import React from "react";
import F1ChampionshipStandings from "../../formula1/F1ChampionshipStandings";
import F1RaceCarousel from "../../formula1/F1RaceCarousel";
import F1RaceDayHero from "../../formula1/F1RaceDayHero";

const F1WidgetWrap = ({
  dataId,
  dataType,
  sport,
  data,
  baseUrl,
  loadCSS,
  dataClient = false,
  dataTitle,
  date,
}) => {
  switch (dataType) {
    // "Classifica Campionato" — driver + constructor championship standings.
    case "f1-standings":
    case "f1-championship-standings":
      return (
        <F1ChampionshipStandings
          serverData={data?.data}
          dataId={dataId}
          baseUrl={baseUrl}
          sport={sport}
          loadCSS={loadCSS}
          dataClient={dataClient}
          title={dataTitle || "Championship Standings"}
        />
      );

    // Race-calendar carousel (podiums / schedules).
    case "f1-races":
    case "f1-race-calendar":
      return (
        <F1RaceCarousel
          serverData={data?.data}
          dataId={dataId}
          baseUrl={baseUrl}
          sport={sport}
          loadCSS={loadCSS}
          dataClient={dataClient}
          date={date}
        />
      );

    // Race-day hero — a single Grand Prix detail card (data-id = race id, else current race).
    case "f1-race-hero":
    case "f1-race-day":
      return (
        <F1RaceDayHero
          serverData={data?.data}
          dataId={dataId}
          baseUrl={baseUrl}
          sport={sport}
          loadCSS={loadCSS}
          dataClient={dataClient}
          date={date}
        />
      );

    default:
      return <h1>Widget Not Found in Formula 1!</h1>;
  }
};

export default F1WidgetWrap;
